import React, { useState } from "react";
import PropTypes from 'prop-types'
import { connect } from "react-redux";

//
import { FormControl, Card, Row, Col, Form } from "react-bootstrap";

//
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//
import * as yup from "yup";
import { Formik } from "formik";

//
import { sendInviteLink } from "../../../redux/features/user/actions";

//
import BoxLoading from "../../general/BoxLoading";


//
const schema = yup.object().shape({
  email: yup.string().email().required(),
});

function Invite({user}) {
  const [loading, setLoading] = useState(false);

  /**
   * Send Invite Link
   */
  const send_invite_link = (e, { resetForm }) => {
    // start loading
    setLoading(true);

    // send request
    sendInviteLink(e).then((res) => {
      if (res) {
        setLoading(false);
        resetForm({
          values: "",
        });
      } else {
        setLoading(false);
      }
    });
  };

  /**
   * Copy To Clipboard
   */
  const copy = () => {
    let val = `${window.origin}/#/auth/register?referral=${user.affiliate_code}`;
    
    let tempInput = document.createElement("input");

    tempInput.value = val;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");

    toast.success("copy to clipboard", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });
    document.body.removeChild(tempInput);
  };

  return (
    <div className="invite">
      <Card className="banner">
        <Card.Body>
          <Row>
            <Col md={7} lg={8} xxl={5}>
              <h4 className="text-white">
                Invite Your Friend to Invalert and get special gifts from us!
              </h4>
            </Col>
          </Row>
          <div className="link">
            <Formik
              validationSchema={schema}
              onSubmit={send_invite_link}
              initialValues={{
                email: "",
              }}
            >
              {({ handleSubmit, handleChange, touched, errors, values }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <FormControl
                    type="email"
                    name="email"
                    placeholder="Write email here..."
                    onChange={handleChange}
                    autoComplete="off"
                    value={values.email}
                    isInvalid={touched.email && !!errors.email}
                  />
                </Form>
              )}
            </Formik>
            <p>
              or copy link <span onClick={() => copy()}>here!</span>
            </p>
          </div>
        </Card.Body>

        {loading && <BoxLoading />}
      </Card>
      <div className="space"></div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

Invite.propTypes = {
  user: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Invite);
